import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

export default function SsoCallback() {
  const [params] = useSearchParams();
  const [error, setError] = useState("");
  useEffect(() => {
    const code = params.get("code");
    const next = params.get("next") || "/";
    const safe = next.startsWith("/") && !next.startsWith("//") ? next : "/";
    if (!code) { setError("Missing sign-in code"); return; }
    api.post("/sso/redeem", { code })
      .then(() => { window.location.replace(safe); })
      .catch((e) => setError(e?.response?.data?.detail || "Sign-in link expired"));
  }, [params]);
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6 text-center" data-testid="sso-callback">
      {error ? (
        <div><div className="text-[#FF003C] font-bold">{error}</div><a href="/login" className="text-[#00F0FF] mono text-xs uppercase mt-3 inline-block">Sign in</a></div>
      ) : <div className="mono text-xs text-[#00F0FF] animate-pulse">Signing you in with your Jixxeo account…</div>}
    </div>
  );
}
